import Request from '@/core/QuRequest';

const req = new Request();

export default {
  methods: {
    // 获取公共参数
    getParams() {
      const params = {
        department_id: this.sale[0],
        sales_id: this.sale[1],
      };
      return params;
    },

    // 我的业绩
    async queryDirectPerformance() {
      try {
        this.loading = true;

        const params = this.getParams();
        const res = await req.send(
          req.Apis.sales.report.directPerformance,
          params,
        );

        this.loading = false;

        if (res.code === 200) {
          this.performance = res.data;
        }
      } catch (err) {
        this.loading = false;
        this.$message.error(err.message);
      }
    },

    // 业绩风云榜+完成率风云榜接口
    async queryDirectRanking() {
      try {
        const res = await req.send(req.Apis.sales.report.directRanking);
        if (res.code === 200) {
          this.rank = res.data;
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },

    // 漏斗
    async queryDirectFunnel() {
      try {
        const params = this.getParams();
        const res = await req.send(req.Apis.sales.report.directFunnel, params);
        if (res.code === 200) {
          this.funnel = res.data;
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },
  },
};
